import { Flex, Link, Paragraph, Text, Tooltip } from "@/atoms"
import { ExternalLinkOutlined, LinkOutlined } from "@/icons"

import styles from "./HighProfileVulnerability.module.scss"

import type { ReferenceHighProfileVulnerabilityProps } from "."

export const ReferenceHighProfileVulnerability = (
  props: ReferenceHighProfileVulnerabilityProps
) => {
  const { type, references, t } = props

  if (!references?.length) return null

  const count = references.length

  return (
    <Flex align="center" gap={4}>
      <Text type={type}>
        <LinkOutlined className={styles.referenceIcon} />
      </Text>
      <Tooltip
        overlayClassName={styles.tooltip}
        title={
          <Flex vertical gap={16}>
            {references.map((reference, index) => (
              <Link
                key={index}
                type="link-hover"
                target="_blank"
                href={reference.url}
              >
                <Flex gap={20} align="start">
                  <Flex vertical>
                    <span className={styles.fW500}>{reference.hostname}</span>
                    {reference.hostname && (
                      <Paragraph
                        type="secondary"
                        className="sm-text-ks"
                        ellipsis={{ rows: 2 }}
                      >
                        {reference.label}
                      </Paragraph>
                    )}
                  </Flex>
                  <ExternalLinkOutlined
                    className={styles.referenceExternalIcon}
                  />
                </Flex>
              </Link>
            ))}
          </Flex>
        }
      >
        <Text type={type} className={styles.referenceText}>
          {count === 1 && references[0]?.hostname}
          {count > 1 && `${count} ${t("general.source", { count })}`}
        </Text>
      </Tooltip>
    </Flex>
  )
}
